import { createTheme } from "@mui/material";

export const MainTheme = createTheme({
  palette: {
    text: {
      primary: "rgba(0, 0, 0, 0.87)",
      secondary: "rgba(0, 0, 0, 0.6)",
      disabled: "rgba(0, 0, 0, 0.38)",
    },
    primary: {
      light: "rgba(150, 54, 150, 1)",
      main: "rgba(105, 32, 111, 1)",
      dark: "rgba(69, 5, 74, 1)",
      contrastText: "rgba(255, 255, 255, 1)",
      50: "#FAF4FC",
      100: "#dfbdd9",
      200: "#ca92c1",
      300: "#b468a8",
      400: "#a34a96",
      500: "#933086",
      600: "#872b80",
      700: "#772578",
      800: "#68206f",
      900: "#4e195e",
      A100: "#872b80",
      A200: "#772578",
      A400: "#68206f",
      A700: "#4e195e",
    },
    secondary: {
      light: "rgba(97, 56, 105, 1)",
      main: "rgba(71, 41, 76, 1)",
      dark: "rgba(55, 32, 59, 1)",
      50: "#f0e6ee",
      100: "#dbc0d5",
      200: "#c598bb",
      300: "#ac729f",
      400: "#9a588c",
      500: "#88447a",
      600: "#7d3e74",
      700: "#6f376b",
      800: "#603260",
      900: "#47294c",
      A100: "#7d3e74",
      A200: "#6f376b",
      A400: "#603260",
      A700: "#47294c",
    },
    action: {
      active: "rgba(0, 0, 0, 0.56)",
      hover: "rgba(0, 0, 0, 0.04)",
      selected: "rgba(0, 0, 0, 0.08)",
      disabledbackground: "rgba(0, 0, 0, 0.12)",
      focus: "rgba(0, 0, 0, 0.12)",
      disabled: "rgba(0, 0, 0, 0.38)",
    },
    error: {
      dark: "rgba(227, 7, 7, 1)",
      main: "rgba(249, 50, 50, 1)",
      light: "rgba(249, 75, 75, 1)",
      contrast: "rgba(255, 255, 255, 1)",
      states: {
        outlinedborder: "rgba(249, 50, 50, 0.5)",
      },
    },
    warning: {
      light: "rgba(242, 143, 50, 1)",
      main: "rgba(240, 129, 26, 1)",
      dark: "rgba(222, 114, 14, 1)",
      contrast: "rgba(255, 255, 255, 1)",
      states: {
        outlinedborder: "rgba(237, 108, 2, 0.5)",
      },
    },
    info: {
      main: "rgba(2, 136, 209, 1)",
      dark: "rgba(1, 87, 155, 1)",
      light: "rgba(3, 169, 244, 1)",
      contrast: "rgba(255, 255, 255, 1)",
      states: {
        outlinedborder: "rgba(2, 136, 209, 0.5)",
      },
    },
    success: {
      light: "rgba(5, 192, 36, 1)",
      main: "rgba(4, 153, 28, 1)",
      dark: "rgba(3, 120, 23, 1)",
      contrast: "rgba(255, 255, 255, 1)",
      states: {
        outlinedborder: "rgba(4, 153, 28, 0.5)",
      },
    },
    background: {
      default: "rgba(255, 255, 255, 1)",
      paper: "rgba(255, 255, 255, 1)",
    },
    grey: {
      50: "rgba(250, 250, 250, 1)",
      100: "rgba(245, 245, 245, 1)",
      200: "rgba(238, 238, 238, 1)",
      300: "rgba(224, 224, 224, 1)",
      400: "rgba(189, 189, 189, 1)",
      500: "rgba(158, 158, 158, 1)",
      600: "rgba(117, 117, 117, 1)",
      700: "rgba(97, 97, 97, 1)",
      800: "rgba(66, 66, 66, 1)",
      900: "rgba(33, 33, 33, 1)",
      A100: "rgba(213, 213, 213, 1)",
      A200: "rgba(170, 170, 170, 1)",
      A400: "rgba(97, 97, 97, 1)",
      A700: "rgba(48, 48, 48, 1)",
    },
  },
  typography: {
    link_large: {
      fontSize: 14,
      fontFamily: "Poppins, sans-serif",
      paragraphIndent: 0,
      paragraphSpacing: 0,
      fontWeight: 400,
      letterSpacing: "0%",
      lineHeight: "auto",
    },
    link_medium: {
      fontSize: 12,
      fontFamily: "Poppins, sans-serif",
      paragraphIndent: 0,
      paragraphSpacing: 0,
      fontWeight: 400,
      letterSpacing: "0%",
      lineHeight: "auto",
    },
    link_small: {
      fontSize: 12,
      fontFamily: "Poppins, sans-serif",
      paragraphIndent: 0,
      paragraphSpacing: 0,
      fontWeight: 400,
      letterSpacing: "0%",
      lineHeight: "auto",
    },
    small_text1: {
      fontSize: 15,
      fontFamily: "Poppins, sans-serif",
      paragraphIndent: 0,
      paragraphSpacing: 0,
      fontWeight: 400,
      letterSpacing: "0%",
      lineHeight: "auto",
    },
    small_text2: {
      fontSize: 10,
      fontFamily: "Open Sans, sans-serif",
      paragraphIndent: 0,
      paragraphSpacing: 0,
      fontWeight: 400,
      letterSpacing: "0%",
      lineHeight: "auto",
    },
    "masthead-menu": {
      fontSize: 10,
      fontFamily: "Poppins, sans-serif",
      paragraphIndent: 0,
      paragraphSpacing: 0,
      fontWeight: 400,
      letterSpacing: "0%",
      lineHeight: "auto",
    },
    card_label1: {
      fontSize: 8,
      fontFamily: "Poppins, sans-serif",
      paragraphIndent: 0,
      paragraphSpacing: 0,
      fontWeight: 600,
      letterSpacing: "0px",
      lineHeight: "14px",
    },
    card_lable2: {
      fontSize: 8,
      fontFamily: "Poppins, sans-serif",
      paragraphIndent: 0,
      paragraphSpacing: 0,
      fontWeight: 500,
      letterSpacing: "0%",
      lineHeight: "auto",
    },
    card_label3: {
      fontSize: 8,
      fontFamily: "Open Sans, sans-serif",
      paragraphIndent: 0,
      paragraphSpacing: 0,
      fontWeight: 400,
      letterSpacing: "0%",
      lineHeight: "auto",
    },
    h1: {
      fontSize: 34,
      fontFamily: "Poppins, sans-serif",
      paragraphIndent: 0,
      paragraphSpacing: 0,
      fontWeight: 500,
      letterSpacing: "0.25px",
      lineHeight: "123.50000143051147%",
    },
    h2: {
      fontSize: 24,
      fontFamily: "Poppins, sans-serif",
      paragraphIndent: 0,
      paragraphSpacing: 0,
      fontWeight: 600,
      letterSpacing: "0px",
      lineHeight: "133.39999914169312%",
    },
    h3: {
      fontSize: 20,
      fontFamily: "Poppins, sans-serif",
      paragraphIndent: 0,
      paragraphSpacing: 0,
      fontWeight: 500,
      letterSpacing: "0.15000000596046448px",
      lineHeight: "160.0000023841858%",
    },
    h4: {
      fontSize: 16,
      fontFamily: "Poppins, sans-serif",
      paragraphIndent: 0,
      paragraphSpacing: 0,
      fontWeight: 500,
      letterSpacing: "0%",
      lineHeight: "auto",
    },
    "applicabilityview,1st,2nd group and parameter heading": {
      fontSize: 16,
      fontFamily: "Poppins, sans-serif",
      paragraphIndent: 0,
      paragraphSpacing: 0,
      fontWeight: 400,
      letterSpacing: "0%",
      lineHeight: "116.68164730072021%",
    },
    p1: {
      fontSize: 16,
      fontFamily: "Open Sans, sans-serif",
      paragraphIndent: 0,
      paragraphSpacing: 0,
      fontWeight: 600,
      letterSpacing: "0.15000000596046448px",
      lineHeight: "150%",
    },
    p2: {
      fontSize: 16,
      fontFamily: "Open Sans, sans-serif",
      paragraphIndent: 0,
      paragraphSpacing: 0,
      fontWeight: 400,
      letterSpacing: "0.15000000596046448px",
      lineHeight: "175%",
    },
    p3: {
      fontSize: 14,
      fontFamily: "Open Sans, sans-serif",
      paragraphIndent: 0,
      paragraphSpacing: 0,
      fontWeight: 600,
      letterSpacing: "0.17000000178813934px",
      lineHeight: "142.99999475479126%",
    },
    p4: {
      fontSize: 14,
      fontFamily: "Open Sans, sans-serif",
      paragraphIndent: 0,
      paragraphSpacing: 0,
      fontWeight: 400,
      letterSpacing: "0.10000000149011612px",
      lineHeight: "157.00000524520874%",
    },
    p5: {
      fontSize: 12,
      fontFamily: "Open Sans, sans-serif",
      paragraphIndent: 0,
      paragraphSpacing: 0,
      fontWeight: 400,
      letterSpacing: "0%",
      lineHeight: "auto",
    },
    form_h1: {
      fontSize: 14,
      fontFamily: "Open Sans, sans-serif",
      paragraphIndent: 0,
      paragraphSpacing: 0,
      fontWeight: 600,
      letterSpacing: "0.4000000059604645px",
      lineHeight: "165.9999966621399%",
    },
    form_text1: {
      fontSize: 14,
      fontFamily: "Open Sans, sans-serif",
      paragraphIndent: 0,
      paragraphSpacing: 0,
      fontWeight: 400,
      letterSpacing: "0%",
      lineHeight: "auto",
    },
    form_text2: {
      fontSize: 12,
      fontFamily: "Open Sans, sans-serif",
      paragraphIndent: 0,
      paragraphSpacing: 0,
      fontWeight: 400,
      letterSpacing: "0%",
      lineHeight: "auto",
    },
    form_text3: {
      fontSize: 10,
      fontFamily: "Open Sans, sans-serif",
      paragraphIndent: 0,
      paragraphSpacing: 0,
      fontWeight: 400,
      letterSpacing: "0%",
      lineHeight: "auto",
    },
    naviagtion_selected: {
      fontSize: 12,
      fontFamily: "Poppins, sans-serif",
      paragraphIndent: 0,
      paragraphSpacing: 0,
      fontWeight: 600,
      letterSpacing: "0.4000000059604645px",
      lineHeight: "165.9999966621399%",
    },
    navigation_regular: {
      fontSize: 12,
      fontFamily: "Poppins, sans-serif",
      paragraphIndent: 0,
      paragraphSpacing: 0,
      fontWeight: 400,
      letterSpacing: "0.4000000059604645px",
      lineHeight: "165.9999966621399%",
    },
    "components/date-picker-current-month": {
      fontSize: 16,
      fontFamily: "Open Sans, sans-serif",
      paragraphIndent: 0,
      paragraphSpacing: 0,
      fontWeight: 600,
      letterSpacing: "0.15000000596046448px",
      lineHeight: "150%",
    },
    "components/bottom-navigation-active-label": {
      fontSize: 14,
      fontFamily: "Open Sans, sans-serif",
      paragraphIndent: 0,
      paragraphSpacing: 0,
      fontWeight: 400,
      letterSpacing: "0.4000000059604645px",
      lineHeight: "165.9999966621399%",
    },
    "components/list-subheader": {
      fontSize: 14,
      fontFamily: "Open Sans, sans-serif",
      paragraphIndent: 0,
      paragraphSpacing: 0,
      fontWeight: 600,
      letterSpacing: "0.10000000149011612px",
      lineHeight: "48px",
    },
    "components/table-header": {
      fontSize: 14,
      fontFamily: "Open Sans, sans-serif",
      paragraphIndent: 0,
      paragraphSpacing: 0,
      fontWeight: 600,
      letterSpacing: "0.17000000178813934px",
      lineHeight: "24px",
    },
    "components/tooltip-label": {
      fontSize: 10,
      fontFamily: "Open Sans, sans-serif",
      paragraphIndent: 0,
      paragraphSpacing: 0,
      fontWeight: 600,
      letterSpacing: "0px",
      lineHeight: "14px",
    },
    "components/input-text": {
      fontSize: 16,
      fontFamily: "Open Sans, sans-serif",
      paragraphIndent: 0,
      paragraphSpacing: 0,
      fontWeight: 400,
      letterSpacing: "0.15000000596046448px",
      lineHeight: "24px",
    },
    "components/helper-text": {
      fontSize: 12,
      fontFamily: "Open Sans, sans-serif",
      paragraphIndent: 0,
      paragraphSpacing: 0,
      fontWeight: 400,
      letterSpacing: "0.4000000059604645px",
      lineHeight: "165.9999966621399%",
    },
    "components/input-label": {
      fontSize: 12,
      fontFamily: "Open Sans, sans-serif",
      paragraphIndent: 0,
      paragraphSpacing: 0,
      fontWeight: 400,
      letterSpacing: "0.15000000596046448px",
      lineHeight: "12px",
    },
    "components/field_text1": {
      fontSize: 12,
      fontFamily: "Open Sans, sans-serif",
      paragraphIndent: 0,
      paragraphSpacing: 0,
      fontWeight: 600,
      letterSpacing: "0.14000000059604645px",
      lineHeight: "20px",
    },
    "components/avatar-initials": {
      fontSize: 20,
      fontFamily: "Open Sans, sans-serif",
      paragraphIndent: 0,
      paragraphSpacing: 0,
      fontWeight: 400,
      letterSpacing: "0.14000000059604645px",
      lineHeight: "20px",
    },
    "components/chip-label": {
      fontSize: 13,
      fontFamily: "Open Sans, sans-serif",
      paragraphIndent: 0,
      paragraphSpacing: 0,
      fontWeight: 400,
      letterSpacing: "0.1599999964237213px",
      lineHeight: "18px",
    },
    "components/xs-label": {
      fontSize: 8,
      fontFamily: "Open Sans, sans-serif",
      paragraphIndent: 0,
      paragraphSpacing: 0,
      fontWeight: 400,
      letterSpacing: "0%",
      lineHeight: "auto",
    },
    "components/menu/menu-item-dense": {
      fontSize: 14,
      fontFamily: "Poppins, sans-serif",
      paragraphIndent: 0,
      paragraphSpacing: 0,
      fontWeight: 400,
      letterSpacing: "0.17000000178813934px",
      lineHeight: "24px",
    },
    "components/menu/menu-item": {
      fontSize: 16,
      fontFamily: "Poppins, sans-serif",
      paragraphIndent: 0,
      paragraphSpacing: 0,
      fontWeight: 400,
      letterSpacing: "0.15000000596046448px",
      lineHeight: "150%",
    },
    "components/buttontext/button-small": {
      fontSize: 13,
      fontFamily: "Poppins, sans-serif",
      paragraphIndent: 0,
      paragraphSpacing: 0,
      fontWeight: 500,
      letterSpacing: "0.46000000834465027px",
      lineHeight: "22px",
    },
    "components/buttontext/button-medium": {
      fontSize: 14,
      fontFamily: "Poppins, sans-serif",
      paragraphIndent: 0,
      paragraphSpacing: 0,
      fontWeight: 500,
      letterSpacing: "0.4000000059604645px",
      lineHeight: "24px",
    },
    "components/buttontext/button-large": {
      fontSize: 15,
      fontFamily: "Poppins, sans-serif",
      paragraphIndent: 0,
      paragraphSpacing: 0,
      fontWeight: 500,
      letterSpacing: "0.46000000834465027px",
      lineHeight: "26px",
    },
    "components/alerts/alert-description": {
      fontSize: 14,
      fontFamily: "Open Sans, sans-serif",
      paragraphIndent: 0,
      paragraphSpacing: 0,
      fontWeight: 600,
      letterSpacing: "0.15000000596046448px",
      lineHeight: "142.99999475479126%",
    },
    "components/alerts/alert-title": {
      fontSize: 16,
      fontFamily: "Open Sans, sans-serif",
      paragraphIndent: 0,
      paragraphSpacing: 0,
      fontWeight: 600,
      letterSpacing: "0.15000000596046448px",
      lineHeight: "150%",
    },
    "components/role-card/name": {
      fontSize: 8,
      fontFamily: "Poppins, sans-serif",
      paragraphIndent: 0,
      paragraphSpacing: 0,
      fontWeight: 600,
      letterSpacing: "0%",
      lineHeight: "auto",
    },
    "components/role-card/info": {
      fontSize: 8,
      fontFamily: "Poppins, sans-serif",
      paragraphIndent: 0,
      paragraphSpacing: 0,
      fontWeight: 500,
      letterSpacing: "0%",
      lineHeight: "auto",
    },
  },
  components: {
    MuiPaper: {
      styleOverrides: {
        root: {
          borderRadius: "12px",
          padding: "15px",
        },
      },
    },
    MuiTabs: {
      defaultProps: {
        TabIndicatorProps: {
          style: {
            display: "none",
          },
        },
      },
      styleOverrides: {
        scroller: {
          display: "inline-flex",
        },
        flexContainer: {
          display: "inline-flex",
        },
        root: {
          display: "inline-flex",
          border: "1px solid #EEEFF0",
          padding: "3px",
          borderRadius: "12px",
          minHeight: "0",
          height: "37px",
          "& button": {
            fontFamily: "Public Sans, sans-serif",
            fontSize: "14px",
            fontWeight: 400,
            lineHeight: "21px",
            letterSpacing: "0em",
            textAlign: "left",
            textTransform: "capitalize",
            padding: "10px 5px",
            minHeight: "0",
          },
          "& button.Mui-selected": {
            backgroundColor: "#FAF4FC",
            borderRadius: "9px",
            boxShadow: "2px 2px 5px 0px #B1AEBB",
            margin: "5px 2.5px",
          },
        },
      },
    },
    MuiButtonGroup: {
      styleOverrides: {
        root: {
          "& button": {
            textTransform: "capitalize",
            color: "black",
            padding: "0px 6px",
          },
          "& button.MuiButtonGroup-grouped:not(:last-of-type)": {
            borderRight: "1px solid #bdbdbd",
          },
        },
      },
    },
    MuiCheckbox: {
      styleOverrides: {
        root: {
          color: "rgba(150, 54, 150, 1)",
        },
      },
    },
  },
});
